import { useState } from 'react';
import { ChevronDown, ChevronRight, Trash2, Loader as LoaderIcon } from 'react-feather';
import Modal from 'react-modal';

Modal.setAppElement('#app');

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        border: 'none',
        background: 'none',
        padding: 0,
        overflow: 'visible',
    },
};

const OrderStatusSection = ({
	sections,
	toggleSection,
	handleSubmit,
	handleStatus,
	register,
	sendToDesign,
	envelopeId,
    watch,
    setValue,
    onPreviewContract,
    isSending,
    isPreparingContract,
}) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const confirmDelete = () => {
        handleStatus({ status: -1 });
        setShowDeleteModal(false);
    };
	return (
		<>
			<div className="tab-information">
				<div className="status-box-block">
					<div
						className="title-block"
						onClick={() => toggleSection('statussection')}
					>
						<h2 className="title-h2">Order Status</h2>
						<button type="button">
							{sections.statussection ? (
								<ChevronDown size={24} />
							) : (
								<ChevronRight size={24} />
							)}
						</button>
					</div>
					{sections.statussection && (
						<>
							<div className="content-box">
								<form
									onSubmit={handleSubmit(handleStatus)}
									className="px-8 pb-8 mb-4"
								>
									<div className="mb-6">
										<label
											className="block text-slate-700 text-sm font-bold mb-4"
										>
											Current Status: <span className="font-normal text-slate-500">Select a new status and click Update</span>
										</label>
										
                                        <div className="flex flex-wrap gap-3">
                                            {[
                                                { id: '1', label: 'Quote', color: 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200' },
                                                { id: '2', label: 'Order Set', color: 'bg-indigo-100 text-indigo-800 border-indigo-200 hover:bg-indigo-200' },
                                                { id: '3', label: 'Permits', color: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-200' },
                                                { id: '4', label: 'Invoice', color: 'bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-200' },
                                                { id: '5', label: 'Installation', color: 'bg-cyan-100 text-cyan-800 border-cyan-200 hover:bg-cyan-200' },
                                                { id: '6', label: 'Repair', color: 'bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-200' },
                                                { id: '7', label: 'Review', color: 'bg-pink-100 text-pink-800 border-pink-200 hover:bg-pink-200' },
                                                { id: '10', label: 'Done', color: 'bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-200' },
                                            ].map((status) => {
                                                const currentStatus = watch('status');
                                                // Check if this status is selected (handling string/number types)
                                                // eslint-disable-next-line eqeqeq
                                                const isActive = currentStatus == status.id; 
                                                
                                                return (
                                                    <button
                                                        key={status.id}
                                                        type="button"
                                                        onClick={() => setValue('status', status.id)}
                                                        className={`
                                                            px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200 border
                                                            ${status.color}
                                                            ${isActive ? 'ring-2 ring-offset-2 ring-slate-400 scale-105 shadow-md' : 'opacity-80 hover:opacity-100'}
                                                        `}
                                                    >
                                                        {status.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        {/* Hidden Select for Form Registration if needed, though setValue handles it */}
                                        <select 
                                            {...register('status')} 
                                            className="hidden"
                                        >
                                            <option value="1">Quote</option>
                                            <option value="2">Order Set</option>
                                            <option value="3">Permits</option>
                                            <option value="4">Invoice</option>
                                            <option value="5">Installation</option>
                                            <option value="6">Repair</option>
                                            <option value="7">Review</option>
                                            <option value="10">Done</option>
                                        </select>
									</div>

									<button type="submit" className="redBtn w-full md:w-auto">
										Update Status
									</button>
								</form>
							</div>
						</>
					)}
				</div>
			</div>

            {/* Delete Order Button */}
            {sections.statussection && (
                 <div className="flex justify-end mt-4 px-8">
                    <button
                        type="button"
                        onClick={() => setShowDeleteModal(true)}
                        className="flex items-center gap-2 text-red-600 hover:text-red-800 font-medium px-4 py-2 hover:bg-red-50 rounded-md transition-colors"
                    >
                        <Trash2 size={18} />
                        Delete Order
                    </button>
                </div>
            )}

            <Modal
                isOpen={showDeleteModal}
                onRequestClose={() => setShowDeleteModal(false)}
                style={customStyles}
                contentLabel="Delete Confirmation"
            >
                <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                    <h2 className="text-xl font-bold mb-4 text-slate-800">Delete Order</h2>
                    <p className="text-slate-600 mb-6">
                        Are you sure you want to delete this order? This action cannot be undone.
                    </p>
                    <div className="flex justify-end gap-3">
                        <button
                            onClick={() => setShowDeleteModal(false)}
                            className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-md transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={confirmDelete}
                            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
                        >
                            Yes, Delete
                        </button>
                    </div>
                </div>
            </Modal>

			{/*  Two buttons one to send a contract and the other view in 3D design*/}
			<div className="flex flex-col md:flex-row mt-4 gap-4">
				<button className="redBtn w-1/4 mt-4 " onClick={sendToDesign}>
					View in 3D Design
				</button>
                <button 
                    className="redBtn w-1/4 mt-4 bg-blue-600 hover:bg-blue-700 flex items-center justify-center gap-2" 
                    onClick={onPreviewContract}
                    disabled={isSending || isPreparingContract}
                >
					{isSending || isPreparingContract ? (
                        <>
                            <LoaderIcon className="animate-spin" size={18} />
                            <span>{isPreparingContract ? 'Preparing...' : 'Sending...'}</span>
                        </>
                    ) : 'Preview Contract'}
				</button>
			</div>
			{envelopeId && (
				<div className="w-full">Envelope Sent! ID: {envelopeId}</div>
			)}
		</>
	);
};

export default OrderStatusSection;
